<template>
  <div class="compliance-dashboard">
    <!-- Blur background image container -->
    <div class="blur-background" :style="backgroundImageStyle"></div>
    <title-bar :title-stack="titleStack" @loadOverView="GoBack()" />
    <hero-bar>
      Compliance Cost {{ pageName }}
      <div slot="right">
        <button
          class="button is-normal compliance-back-button"
          @click="clickedBackButton"
          v-if="isFinalBreakDownPage"
        >
          &nbsp; &nbsp;Back&nbsp; &nbsp;
        </button>
        <button
          class="button is-normal"
          @click="GoBack()"
          v-if="headerText != 'overview'"
        >
          &nbsp; &nbsp;Go to Overview&nbsp; &nbsp;
        </button>
      </div></hero-bar
    >
    <section
      class="section is-main-section compliance-section"
      :class="{ 'content-overlay': hasComplianceCostPermission }"
    >
      <!-- Permission Denied Message - This div is only rendered when user doesn't have permission -->
      <template v-if="!hasComplianceCostPermission">
        <div class="permission-card permission-background">
          <div class="card">
            <div class="card-content">
              <div class="columns is-variable">
                <div class="column permission-content">
                  <div class="permission-heading mb-4">
                    <h3 class="title is-3 has-text-weight-bold">
                      Unlock visibility into your EPR compliance costs
                    </h3>
                  </div>
                </div>
                <div class="column is-narrow permission-image">
                  <img
                    src="~@/assets/compliance-lock.png"
                    alt="Compliance dashboard lock"
                    class="permission-icon"
                  />
                </div>
              </div>
              <div class="columns is-variable">
                <div class="column is-narrow permission-text">
                  <p class="subtitle is-6 mb-2">
                    This area is currently in development. Soon, you will be
                    able to view compliance costs per product, stream, and
                    country, enabling better planning and cost management.
                  </p>
                  <!-- <p class="contact-text mb-4">
                    Contact your Customer Account Manager today to learn more.
                    We’re here to help you get started.
                  </p> -->
                </div>
              </div>
              <div class="columns is-variable">
                <div class="column has-text-centered">
                  <button
                    class="button is-primary center-button"
                    @click="redirectToDashboard"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- Main content (only shown if user has permission) -->
      <template v-if="hasComplianceCostPermission">
        <compliance-filter
          :filterSchemeDropDown="filterSchemeDropDown"
          :filterCountryDropDown="filterCountryDropDown"
          @sortBy="filterBySort"
          @selectedCountry="filterBySelectedCountry"
          @selectedSchemes="filterBySelectedScheme"
          @dateRangeChanged="filterByDateRange"
          @loadProductByCountry="getProductFeesData"
          :selectedCountry="selectedCountry"
          :selectedScheme="selectedScheme"
          @exportData="exportData"
          :headerText="headerText"
        >
        </compliance-filter>
        <div class="level global-fee-bold" v-if="headerText == 'overview'">
          <div class="level-right">
            <h1>Total Global Fees</h1>
          </div>
          <div class="level-left">
            <h1>
              {{
                globalFee
                  ? globalFee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                    " &euro;"
                  : ""
              }}
              <span class="asterisk">&#42;</span>
            </h1>
          </div>
        </div>
        <div class="columns is-desktop" v-if="headerText == 'overview'">
          <div class="column">
            <compliance-graph-card
              :headerText="'country'"
              :pieChart="true"
              :pieChartFees="countryFees"
              :pieChartLabel="countryCategories"
              :contentData="countryData.slice(0, 3)"
              @moreDetails="moreDetailsCountry"
              :filter="filter"
            ></compliance-graph-card>
          </div>
          <div class="column">
            <compliance-graph-card
              :headerText="'stream'"
              :pieChart="true"
              :pieChartFees="streamFees"
              :pieChartLabel="streamLabel"
              :contentData="dataStream.slice(0, 3)"
              @moreDetails="moreDetailsStream"
              :filter="filter"
            ></compliance-graph-card>
          </div>
          <div
            class="column is-hidden-mobile is-full-tablet is-hidden-desktop-only is-hidden-widescreen-only is-one-third-fullhd"
          >
            <compliance-graph-card
              :headerText="'scheme'"
              :pieChart="true"
              :pieChartFees="schemeFees"
              :pieChartLabel="schemeCategories"
              :content-data="dataScheme.slice(0, 3)"
              @moreDetails="moreDetailsScheme"
              :filter="filter"
            ></compliance-graph-card>
          </div>
        </div>
        <div class="lavel no-margin" v-if="headerText == 'overview'">
          <div class="columns is-desktop">
            <div
              class="column is-hidden-tablet-only is-hidden-fullhd is-half-fullhd"
            >
              <compliance-graph-card
                :headerText="'scheme'"
                :pieChart="true"
                :pieChartFees="schemeFees"
                :pieChartLabel="schemeCategories"
                :content-data="dataScheme.slice(0, 3)"
                @moreDetails="moreDetailsScheme"
                :filter="filter"
              ></compliance-graph-card>
            </div>
            <div
              class="column is-hidden-tablet-only is-hidden-fullhd is-half-fullhd"
            >
              <compliance-graph-card
                :headerText="'product'"
                :contentData="productContnetData"
                @moreDetails="moreDetailsProduct"
                :filter="filter"
              ></compliance-graph-card>
            </div>
            <div
              class="column is-hidden-mobile is-full-tablet is-hidden-desktop-only is-hidden-widescreen-only product-full"
            >
              <compliance-graph-card
                :headerText="'product'"
                :contentData="productContnetData"
                @moreDetails="moreDetailsProduct"
                :filter="filter"
              ></compliance-graph-card>
            </div>
          </div>
        </div>
        <div class="lavel more-details-country" v-if="headerText == 'country'">
          <div
            class="columns"
            v-for="(rowIdx, k) in Math.ceil(
              Object.values(detailData).length / 3
            )"
            :key="k"
          >
            <div
              class="column is-4 is-6-mobile"
              v-for="(item, key) in Object.keys(detailData).slice(
                3 * (rowIdx - 1),
                3 * rowIdx
              )"
              :key="key"
            >
              <country-scheme-detail-card
                :headerText="'country'"
                :contentHeaderData="item"
                :contentData="detailData[item]"
                @changeCountryFilter="changeCountryFilter"
              ></country-scheme-detail-card>
            </div>
          </div>
        </div>
        <div class="lavel more-details-country" v-if="headerText == 'scheme'">
          <div
            class="columns"
            v-for="(rowIdx, k) in Math.ceil(
              Object.values(detailData).length / 2
            )"
            :key="k"
          >
            <div
              class="column is-6"
              v-for="(item, key) in Object.keys(detailData).slice(
                2 * (rowIdx - 1),
                2 * rowIdx
              )"
              :key="key"
            >
              <country-scheme-detail-card
                :contentHeaderData="item"
                :contentData="detailData[item]"
                :headerText="headerText"
                @changeSchemeFilter="changeSchemeFilter"
              ></country-scheme-detail-card>
            </div>
          </div>
        </div>
        <div class="lavel more-details-country" v-if="headerText == 'stream'">
          <div
            class="columns"
            v-for="(rowIdx, k) in Math.ceil(
              Object.values(detailData).length / 2
            )"
            :key="k"
          >
            <div
              class="column is-6"
              v-for="(item, key) in Object.keys(detailData).slice(
                2 * (rowIdx - 1),
                2 * rowIdx
              )"
              :key="key"
            >
              <country-scheme-detail-card
                :contentHeaderData="item"
                :contentData="detailData[item]"
                :headerText="headerText"
                @moreDetails="moreDetailsFinalDrilDown"
              ></country-scheme-detail-card>
            </div>
          </div>
        </div>
        <div class="lavel more-details-country" v-if="isFinalBreakDownPage">
          <FinalBreakdown
            :contentHeaderData="headerText"
            :contentData="detailData"
            @keyName="SetHeaderName"
            @loadFinalTableData="loadFinalTableData"
          ></FinalBreakdown>
        </div>
        <div v-if="headerText == 'product'">
          <product-detail-list
            :contentHeaderData="'product'"
            :contentData="productDetailData"
            :headerText="headerText"
            @loadProductFeeTableData="loadProductFeeTableData"
            :newPage="productNewPage"
          ></product-detail-list>
        </div>
        <section class="section compliance-footer">
          <span class="asterisk" v-if="headerText == 'overview'"
            >&#42; &nbsp;</span
          >
          <span v-if="headerText == 'overview'"
            >Fees calculated in EUR based on average currency conversion rate of
            chosen time period.</span
          >
          <br />
          <span class="asterisk">&#42; &#42; &nbsp;</span>
          <span
            >Fees displayed may differ from the final invoices issued by the
            respective schemes.</span
          >
        </section>
      </template>
      <!-- Close v-if="hasComplianceCostPermission" template -->
    </section>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="true"
      v-if="hasComplianceCostPermission"
    >
    </b-loading>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { UserGroup } from "@/services/UserGroups";
import HeroBar from "@/components/HeroBar";
import TitleBar from "@/components/TitleBar";
import ComplianceFilter from "@/components/Compliance/ComplianceFilter.vue";
import FinalBreakdown from "@/components/Compliance/FinalBreakdown.vue";
import ProductDetailList from "@/components/Compliance/ProductDetailList.vue";
import ComplianceGraphCard from "@/components/Compliance/ComplianceGraphCard.vue";
import CountrySchemeDetailCard from "@/components/Compliance/CountrySchemeDetailCard.vue";
import ComplianceCostService from "../../services/ComplianceCostService";
import utitlityMixin from "@/mixins/UtilityMixin";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import { ComplianceHeaderText } from "../../constants/ComplianceHeaderText";
import {
  CompliancePageNames,
  StreamPageNames
} from "../../constants/CompliancePageNames";
export default {
  name: "ComplianceDashboard",
  mixins: [utitlityMixin],
  components: {
    HeroBar,
    TitleBar,
    ComplianceFilter,
    ComplianceGraphCard,
    CountrySchemeDetailCard,
    FinalBreakdown,
    ProductDetailList
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal",
      "mappedCustomer",
      "switchCustomerView"
    ]),
    backgroundImageStyle() {
      return {
        // Use a gradient that matches the compliance dashboard theme with a more vibrant pattern
        backgroundImage:
          "radial-gradient(circle at 90% 10%, #b3e5fc 0%, rgba(179, 229, 252, 0.3) 30%, rgba(225, 245, 254, 0.5) 60%), linear-gradient(135deg, #f5f5f5 0%, #e0f7fa 40%, #b3e5fc 100%)",
        backgroundAttachment: "fixed"
      };
    },
    titleStack() {
      if (this.headerText == ComplianceHeaderText.COUNTRY) {
        return [
          this.complianceLink,
          { url: "#", name: "Compliance Cost by Country" }
        ];
      } else if (this.headerText == ComplianceHeaderText.STREAM) {
        return [
          this.complianceLink,
          { url: "#", name: "Compliance Cost by Stream" }
        ];
      } else if (this.headerText == ComplianceHeaderText.SCHEME) {
        return [
          this.complianceLink,
          { url: "#", name: "Compliance Cost by Scheme" }
        ];
      } else if (this.headerText == ComplianceHeaderText.PRODUCT) {
        return [
          this.complianceLink,
          { url: "#", name: "Compliance Cost Product Fees" }
        ];
      } else if (this.headerText == ComplianceHeaderText.WEEE) {
        return [
          this.complianceLink,
          { url: "/compliance/stream", name: "Compliance Cost by Stream" },
          { url: "#", name: "WEEE" }
        ];
      } else if (this.headerText == ComplianceHeaderText.BATT) {
        return [
          this.complianceLink,
          { url: "/compliance/stream", name: "Compliance Cost by Stream" },
          { url: "#", name: "Battary" }
        ];
      } else if (this.headerText == ComplianceHeaderText.PACK) {
        return [
          this.complianceLink,
          { url: "/compliance/stream", name: "Compliance Cost by Stream" },
          { url: "#", name: "Packaging" }
        ];
      } else if (this.headerText == ComplianceHeaderText.PAPER) {
        return [
          this.complianceLink,
          { url: "/compliance/stream", name: "Compliance Cost by Stream" },
          { url: "#", name: "Paper" }
        ];
      } else if (this.headerText == ComplianceHeaderText.SUP) {
        return [
          this.complianceLink,
          { url: "/compliance/stream", name: "Compliance Cost by Stream" },
          { url: "#", name: "SUP" }
        ];
      } else if (this.headerText == ComplianceHeaderText.TEXTILES) {
        return [
          this.complianceLink,
          { url: "/compliance/stream", name: "Compliance Cost by Stream" },
          { url: "#", name: "Textiles" }
        ];
      } else {
        return [{ url: "#", name: "Compliance Cost Overview" }];
      }
    }
  },
  props: {
    headerText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      hasComplianceCostPermission: true, // Default to true until checked
      complianceLink: { url: "/compliance", name: "Compliance Cost Overview" },
      isProductDetailList: false,
      isFinalBreakDownPage: false,
      selectedCountry: [],
      selectedScheme: [],
      isCountryDetailActive: false,
      isSchemeDetailActive: false,
      isStreamDetailActive: false,
      isDetailPage: false,
      pageName: localStorage.getItem("pageName")
        ? localStorage.getItem("pageName")
        : "Overview",
      globalFee: null,
      switchCustomerId: null,
      filterCountry: [],
      filterScheme: [],
      filterTo: new Date().toLocaleDateString("fr-CA"),
      hideCountry: false,
      filter: {
        name: "Highest Fee",
        value: "total_fee",
        order: "desc"
      },
      filterFrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 3,
        new Date().getDate()
      ).toLocaleDateString("fr-CA"),
      ComplianceCostService: new ComplianceCostService(),
      countryData: [],
      countryFees: [],
      countryCategories: [],
      streamFees: [],
      streamLabel: [],
      schemeCategories: [],
      schemeFees: [],
      dataStream: [],
      dataScheme: [],
      detailData: {},
      streamDetailData: {},
      schemeDetailData: {},
      productContnetData: [],
      filterSchemeDropDown: [],
      filterCountryDropDown: [],
      CustomerProfileDataService: new CustomerProfileDataService(),
      scope: {},
      dataLoaded: false,
      selectedCountryForProduct: [],
      initialStreamLoaded: true,
      productDetailData: {},
      productNewPage: true,
      isLoading: true
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    if (this.mappedCustomer && this.mappedCustomer.length > 0) {
      this.switchCustomerId = this.mappedCustomer[0];
    }
    // if (
    //   this.userGroups.includes(UserGroup.EXTERNAL_USER) &&
    //   !this.switchCustomerViewEnabled
    // ) {
    //   this.$router.push({ name: "home" });
    // }
    // if (this.switchCustomerId) {
    this.getCountryAndSchemeDropDown();
    // } else {
    //   this.$router.push({ name: "home" });
    // }

    // Force check permission state in next tick to ensure reactivity works
    this.$nextTick(() => {
      console.log(
        "After nextTick - Permission state:",
        this.hasComplianceCostPermission
      );
    });
  },
  watch: {
    headerText(newValue) {
      this.detailData = {};
      this.loadData(newValue, localStorage.getItem("pageName"));
    }
  },
  methods: {
    /*this function is called when export button is clicked.
    Create your own function for export for individual page and put the function
    name accordingly in this below function*/

    //back button clicked and it will reload to stream page
    streamDetailName(page) {
      switch (page) {
        case StreamPageNames.WEEE:
          return {
            name: "weee",
            isTrue: true
          };
        case StreamPageNames.BATT:
          return {
            name: "batt",
            isTrue: true
          };
        case StreamPageNames.PACK:
          return {
            name: "pack",
            isTrue: true
          };
        case StreamPageNames.SUP:
          return {
            name: "sup",
            isTrue: true
          };
        case StreamPageNames.TEXTILES:
          return {
            name: "textiles",
            isTrue: true
          };
        case StreamPageNames.PAPER:
          return {
            name: "paper",
            isTrue: true
          };

        default:
          return {
            name: "",
            isTrue: false
          };
      }
    },
    exportData() {
      const stream_name = this.streamDetailName(this.pageName);
      if (this.pageName == CompliancePageNames.OVERVIEW) {
        console.log("export of the first page overview data button clicked");
      } else if (this.pageName == CompliancePageNames.SCHEME) {
        this.exportSchemeData();
      } else if (this.pageName == CompliancePageNames.STREAM) {
        this.exportStreamData();
      } else if (this.pageName == CompliancePageNames.COUNTRY) {
        this.exportCountryData();
      } else if (this.pageName == CompliancePageNames.PRODUCT) {
        this.exportProductFeesData();
      } else if (stream_name.isTrue) {
        this.exportDetailStreamData(stream_name.name);
      } else {
        return;
      }
    },

    clickedBackButton() {
      this.isFinalBreakDownPage = false;
      this.$router.push({ name: "compliance.stream" }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    loadFinalTableData(value) {
      try {
        this.getFinalBreakdownStreamData(value);
      } catch (e) {
        this.isLoading = false;
      }
    },
    //called when more detail link is clicked on stream page. this will load final breakdown page
    moreDetailsFinalDrilDown() {
      try {
        this.getFinalBreakdownStreamData();
      } catch (e) {
        this.isLoading = false;
      }
    },

    SetHeaderName(value) {
      this.pageName = CompliancePageNames.STREAM + " - " + value;
      this.$store.state.CompliancePageNames = this.pageName;
      localStorage.setItem("pageName", this.pageName);
    },
    //Return to overview page
    GoBack() {
      this.isDetailPage = false;
      this.$router.push({ name: "compliance" }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
      this.isFinalBreakDownPage = false;
    },
    //called when more detail link is clicked on scheme page. this will load steam page
    moreDetailsDrilSchemeDown() {
      this.isDetailPage = true;
      this.$router.push({ name: "compliance.stream" }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
      this.isFinalBreakDownPage = false;
    },
    //when filter change in the top then update country dropdown
    changeCountryFilter(country) {
      this.dataLoaded = true;
      this.selectedCountry = this.filterCountryDropDown.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            t =>
              t.id === value.id && t.name === value.name && t.id == country.id
          )
      );
      this.filterBySelectedCountry(this.selectedCountry);
      this.isDetailPage = true;
      this.$router.push({ name: "compliance.stream" }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
      this.isFinalBreakDownPage = false;
    },
    //when filter change in the top then update scheme dropdown
    changeSchemeFilter(scheme) {
      this.dataLoaded = true;
      this.selectedScheme = this.filterSchemeDropDown.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            t => t.id === value.id && t.name === value.name && t.id == scheme.id
          )
      );
      this.filterScheme = this.selectedScheme;
      this.isDetailPage = true;
      this.$router.push({ name: "compliance.stream" }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
      this.isFinalBreakDownPage = false;
    },
    //called when more detail country link clicked in overview page. this will open country page
    moreDetailsCountry() {
      this.isDetailPage = true;
      this.isFinalBreakDownPage = false;
      this.pageName = CompliancePageNames.COUNTRY;
      this.$router.push({ name: "compliance.country" }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    //called when more detail stream link clicked in overview page. this will open country page
    moreDetailsStream() {
      this.isDetailPage = true;
      this.$router.push({ name: "compliance.stream" }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
      this.isFinalBreakDownPage = false;
    },
    //called when more detail link is clicked on product in overview page. this will load product details page
    moreDetailsProduct() {
      this.isProductDetailList = true;
      this.isDetailPage = true;
      this.pageName = CompliancePageNames.PRODUCT;
      this.$router.push({ name: "compliance.product" }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
      this.isFinalBreakDownPage = false;
    },
    //called when more detail scheme link clicked in overview page. this will open country page
    moreDetailsScheme() {
      this.isDetailPage = true;
      this.$router.push({ name: "compliance.scheme" }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
      this.isFinalBreakDownPage = false;
    },
    //called on page rendered to load the associated data
    loadData(value, oldPage) {
      this.dataLoaded = false;
      if (this.headerText == ComplianceHeaderText.OVERVIEW) {
        this.$store.state.compliancePageName = this.pageName =
          CompliancePageNames.OVERVIEW;
        localStorage.setItem("pageName", CompliancePageNames.OVERVIEW);
        try {
          this.getDashboardData();
        } catch (e) {
          this.isLoading = false;
        }
      } else if (this.headerText == ComplianceHeaderText.SCHEME) {
        this.$store.state.compliancePageName = this.pageName =
          CompliancePageNames.SCHEME;
        localStorage.setItem("pageName", CompliancePageNames.SCHEME);
        try {
          this.getDetailSchemeData();
        } catch (e) {
          this.isLoading = false;
        }
      } else if (this.headerText == ComplianceHeaderText.STREAM) {
        if (
          localStorage.getItem("pageName") == CompliancePageNames.COUNTRY ||
          localStorage.getItem("pageName") == CompliancePageNames.SCHEME
        ) {
          //if (this.initialStreamLoaded) {
          this.$store.state.compliancePageName = this.pageName =
            CompliancePageNames.STREAM;
          // console.log(this.filterCountry.length, "inside");
          if (
            localStorage.getItem("pageName") == CompliancePageNames.COUNTRY &&
            this.filterCountry.length == 1
          ) {
            localStorage.setItem("pageName", CompliancePageNames.STREAM);
            //this.initialStreamLoaded = false;
            try {
              this.getDetailStreamData();
            } catch (e) {
              this.isLoading = false;
            }
          }
          if (
            localStorage.getItem("pageName") == CompliancePageNames.SCHEME &&
            this.filterScheme.length == 1
          ) {
            localStorage.setItem("pageName", CompliancePageNames.STREAM);
            //this.initialStreamLoaded = false;
            try {
              this.getDetailStreamData();
            } catch (e) {
              this.isLoading = false;
            }
          }
          //}
        } else {
          this.$store.state.CompliancePageNames = this.pageName =
            CompliancePageNames.STREAM;
          localStorage.setItem("pageName", CompliancePageNames.STREAM);
          //console.log(this.initialStreamLoaded , this.filterCountry.length, "else");
          try {
            this.getDetailStreamData();
          } catch (e) {
            this.isLoading = false;
          }
        }
      } else if (this.headerText == ComplianceHeaderText.COUNTRY) {
        this.$store.state.CompliancePageNames = CompliancePageNames.COUNTRY;
        localStorage.setItem("pageName", CompliancePageNames.COUNTRY);
        try {
          this.getDetailCountryData();
        } catch (e) {
          this.isLoading = false;
        }
      } else if (this.headerText == ComplianceHeaderText.PRODUCT) {
        this.pageName = this.$store.state.CompliancePageNames =
          CompliancePageNames.PRODUCT;
        localStorage.setItem("pageName", CompliancePageNames.PRODUCT);
        this.productNewPage = true;
        try {
          this.getDetailProductFeesData();
        } catch (e) {
          this.isLoading = false;
        }
      } else {
        try {
          this.getFinalBreakdownStreamData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
    // called when the date range filter changes (both ends at once)
    filterByDateRange({ from, to }) {
      this.filterFrom = from;
      this.filterTo = to;
      this.loadData();
    },
    // called when sorting filter value changed
    filterBySort(value) {
      this.filter = value;
      this.loadData();
    },
    // called when country filter value changed. re-render the depended scheme dropdown based on choosen country
    filterBySelectedCountry(value) {
      this.filterCountry = value;
      let arr = [];
      value.forEach(e => {
        arr.push(this.scope[e.name]);
      });
      arr = arr.reduce((a, b) => a.concat(b), []);
      this.filterScheme = this.filterSchemeDropDown = arr.filter(function(
        item,
        pos
      ) {
        if (
          item.name !== "ERP UK" &&
          item.name !== "ERP Poland" &&
          item.name !== "Ecologic"
        ) {
          return arr.indexOf(item) == pos;
        }
      });
    },
    filterBySelectedScheme(value) {
      this.filterScheme = value;
      if (!this.dataLoaded) {
        this.loadData();
      }
    },
    // Called to get scheme data from backend with all the filter
    getDetailSchemeData() {
      this.detailData = {};
      this.isFinalBreakDownPage = false;
      this.isLoading = true;
      this.ComplianceCostService.getDetailSchemeData(
        this.switchCustomerId,
        this.filterScheme,
        this.filterCountry,
        this.filterFrom,
        this.filterTo,
        this.filter
      ).subscribe(
        response => {
          this.detailData = response;
          this.isLoading = false;
        },
        e => {
          console.log(e);
          this.isLoading = false;
        }
      );
    },
    // send to get stream data from backend with all the selected filters
    getDetailStreamData() {
      this.detailData = {};
      this.isFinalBreakDownPage = false;
      this.isLoading = true;
      this.ComplianceCostService.getDetailStreamData(
        this.switchCustomerId,
        this.filterScheme,
        this.filterCountry,
        this.filterFrom,
        this.filterTo,
        this.filter
      ).subscribe(
        response => {
          this.detailData = response;
          this.isLoading = false;
        },
        e => {
          console.log(e);
          this.isLoading = false;
        }
      );
    },
    exportStreamData() {
      this.isLoading = true;
      this.ComplianceCostService.exportStreamData(
        this.switchCustomerId,
        this.filterScheme,
        this.filterCountry,
        this.filterFrom,
        this.filterTo,
        this.filter
      ).subscribe(() => {
        this.isLoading = false;
      }),
        () => {
          this.isLoading = false;
        };
    },
    exportSchemeData() {
      this.isLoading = true;
      this.ComplianceCostService.exportSchemeData(
        this.switchCustomerId,
        this.filterScheme,
        this.filterCountry,
        this.filterFrom,
        this.filterTo,
        this.filter
      ).subscribe(() => {
        this.isLoading = false;
      }),
        () => {
          this.isLoading = false;
        };
    },
    exportCountryData() {
      this.isLoading = true;
      this.ComplianceCostService.exportCountryData(
        this.switchCustomerId,
        this.filterScheme,
        this.filterCountry,
        this.filterFrom,
        this.filterTo,
        this.filter
      ).subscribe(() => {
        this.isLoading = false;
      }),
        () => {
          this.isLoading = false;
        };
    },
    exportDetailStreamData(page) {
      this.isLoading = true;
      this.ComplianceCostService.exportDetailStreamData(
        this.switchCustomerId,
        this.filterScheme,
        this.filterCountry,
        this.filterFrom,
        this.filterTo,
        this.filter,
        page
      ).subscribe(() => {
        this.isLoading = false;
      }),
        () => {
          this.isLoading = false;
        };
    },
    exportProductFeesData() {
      if (this.selectedCountryForProduct.length > 0) {
        this.isLoading = true;
        this.ComplianceCostService.exportProductFeesData(
          this.switchCustomerId,
          this.selectedCountryForProduct[0]["id"],
          this.filterFrom,
          this.filterTo
        ).subscribe(() => {
          this.isLoading = false;
        }),
          () => {
            this.isLoading = false;
          };
      } else {
        this.$buefy.dialog.alert({
          title: "Export Error",
          type: "is-danger",
          message:
            "You need to select country in dropdown to export Product Fees data"
        });
      }
    },
    // send to get country page data from backend with all the selected filters
    getDetailCountryData() {
      this.detailData = {};
      this.isLoading = true;
      this.ComplianceCostService.getDetailCountryData(
        this.switchCustomerId,
        this.filterScheme,
        this.filterCountry,
        this.filterFrom,
        this.filterTo,
        this.filter
      ).subscribe(
        response => {
          this.isLoading = false;
          this.detailData = response;
        },
        e => {
          this.isLoading = false;
          this.detailData = {};
          console.log(e);
        }
      );
    },
    //get customer associated countries and schemes.
    getCountryAndSchemeDropDown() {
      this.detailData = {};
      this.CustomerProfileDataService.getCustomerById(
        this.switchCustomerId
      ).subscribe(
        response => {
          //created country object with associated shemes as values
          if (response.scope && response.scope.length > 0) {
            response.scope.forEach(e => {
              if (
                this.scope[e.country_of_activity__name] &&
                e.country_of_activity__name != "Poland" &&
                e.country_of_activity__name != "United Kingdom"
              ) {
                this.scope[e.country_of_activity__name].push({
                  name: e.scheme_in_scope__name,
                  id: e.scheme_in_scope
                });
              } else {
                this.scope[e.country_of_activity__name] = [];
                if (
                  e.scheme_in_scope__name != "ERP UK" &&
                  e.scheme_in_scope__name != "ERP Poland" &&
                  e.scheme_in_scope__name != "Ecologic"
                )
                  this.scope[e.country_of_activity__name].push({
                    name: e.scheme_in_scope__name,
                    id: e.scheme_in_scope
                  });
              }
              if (
                e.scheme_in_scope__name !== "ERP UK" &&
                e.scheme_in_scope__name !== "ERP Poland" &&
                e.scheme_in_scope__name !== "Ecologic"
              ) {
                this.filterSchemeDropDown.push({
                  name: e.scheme_in_scope__name,
                  id: e.scheme_in_scope
                });
              }
              if (
                this.scope[e.country_of_activity__name] &&
                e.country_of_activity__name != "Poland" &&
                e.country_of_activity__name != "United Kingdom"
              ) {
                this.filterCountryDropDown.push({
                  name: e.country_of_activity__name,
                  id: e.country_of_activity
                });
              }
            });
          }
          // remove duplicate scheme
          this.filterScheme = this.filterSchemeDropDown.filter(
            (value, index, self) =>
              index ===
              self.findIndex(t => t.id === value.id && t.name === value.name)
          );
          // remove duplicate country
          this.filterCountry = this.filterCountryDropDown.filter(
            (value, index, self) =>
              index ===
              self.findIndex(t => t.id === value.id && t.name === value.name)
          );
          this.loadData();
        },
        e => {
          console.log(e);
        }
      );
    },
    // send to fetch data from backend for overview page
    getDashboardData() {
      this.countryData = [];
      this.dataScheme = [];
      this.dataStream = [];
      this.productContnetData = [];
      this.detailData = {};
      this.isFinalBreakDownPage = false;
      this.isLoading = true;
      this.ComplianceCostService.getComplianceDashboardData(
        this.switchCustomerId,
        this.filterScheme,
        this.filterCountry,
        this.filterFrom,
        this.filterTo,
        this.filter
      ).subscribe(
        response => {
          // Check if permission exists and is explicitly false
          const hasPermission =
            response &&
            response.customer_permission &&
            response.customer_permission.compliance_cost_dashboard !== false;
          // Explicitly set the permission flag
          this.$set(this, "hasComplianceCostPermission", hasPermission);

          if (!hasPermission) {
            // Stop loading indicator
            this.isLoading = false;
          } else {
            // User has permission
            this.hasComplianceCostPermission = true;
            this.globalFee = [];
            this.countryFees = [];
            this.countryCategories = [];
            this.schemeFees = [];
            this.schemeCategories = [];
            this.streamFees = [];
            this.streamLabel = [];
            this.countryData = response.country;
            //object created for overview page country graph data
            this.countryData &&
              this.countryData.forEach(e => {
                // if (e.total_fee) {
                this.countryFees.push(e.total_fee);
                this.countryCategories.push(e.name);
                // }
              });
            this.dataScheme = response.scheme;
            //object created for overview page scheme graph data
            response.scheme &&
              this.dataScheme.forEach(e => {
                if (e.total_fee != "NA") {
                  this.schemeFees.push(parseFloat(e.total_fee));
                  this.schemeCategories.push(e.name);
                }
              });
            //object created for overview page stream graph data
            this.dataStream = response.stream;
            this.dataStream &&
              this.dataStream.forEach(e => {
                //if (e.total_fee) {
                this.streamFees.push(e.total_fee);
                this.streamLabel.push(e.name);
                //}
              });
            //response for product in overview page
            this.productContnetData = response.product;
            if (
              response.global_fee &&
              response.global_fee.length > 0 &&
              response.global_fee[0].total_fee
            ) {
              //rounded the fees to 2 decimal after
              this.globalFee = response.global_fee[0].total_fee;
            }
            this.isLoading = false;
          }
        },
        e => {
          this.isLoading = false;
          console.log(e);
        }
      );
    },
    // get data for final breakdown page
    getFinalBreakdownStreamData(value) {
      this.isLoading = true;
      this.detailData = {};
      this.ComplianceCostService.getFinalStreamData(
        this.switchCustomerId,
        this.filterScheme,
        this.filterCountry,
        this.filterFrom,
        this.filterTo,
        this.filter,
        this.headerText,
        value
      ).subscribe(
        response => {
          this.isLoading = false;
          this.detailData = response;
          this.isFinalBreakDownPage = true;
          this.isDetailPage = true;
        },
        e => {
          this.isLoading = false;
          console.log(e);
        }
      );
    },
    loadProductFeeTableData(value) {
      this.productNewPage = false;
      try {
        this.getDetailProductFeesData(value);
      } catch (e) {
        this.isLoading = false;
      }
    },

    getProductFeesData(value) {
      this.detailData = {};
      this.selectedCountryForProduct = [];
      this.selectedCountryForProduct.push(value);
      this.loadData();
    },
    // get data for product page
    getDetailProductFeesData(value) {
      this.isLoading = true;
      this.detailData = {};
      this.ComplianceCostService.getProductFeesData(
        this.switchCustomerId,
        this.filterFrom,
        this.filterTo,
        this.selectedCountryForProduct,
        value
      ).subscribe(
        response => {
          //console.log(response, response.error);
          if (response.error) {
            this.productDetailData = {};
          } else {
            this.productDetailData = response;
          }
          //this.isFinalBreakDownPage = true;
          this.isDetailPage = true;
          this.isLoading = false;
        },
        e => {
          console.log(e);
          this.isLoading = false;
        }
      );
    },

    // Method to redirect to dashboard when OK button is clicked on permission denied message
    redirectToDashboard() {
      this.$router.push({ name: "home" }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    }
  }
};
</script>

<style scoped>
.permission-card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 400px; /* Increased height to better display the full background image */
}

.permission-background {
  position: relative;
  z-index: 1;
  min-height: 80vh; /* Make it take up at least 80% of the viewport height */
  display: flex;
  justify-content: center;
  align-items: center;
}

.permission-background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("~@/assets/image.jpg");
  background-size: contain; /* Shows the full image */
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.8; /* Reduced opacity to make it more subtle */
  z-index: -1;
  border-radius: 12px;
  filter: blur(0px); /* Light blur effect */
  animation: pulse 10s ease-in-out infinite; /* Add subtle animation */
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.4;
  }
}

.permission-card .card {
  max-width: 400px;
  background-color: rgba(
    255,
    255,
    255,
    0.85
  ); /* Make the card semi-transparent */
  backdrop-filter: blur(1px); /* Modern glass effect */
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.2);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  transition: all 0.3s ease;
  transform: translateY(0);
  animation: fadeInUp 0.6s ease-out;
}

.permission-card .card:hover {
  box-shadow: 0 15px 40px rgba(31, 38, 135, 0.3),
    0 0 15px rgba(25, 118, 210, 0.5); /* Add blue glow */
  transform: translateY(-5px);
}

.permission-card .card-content {
  padding: 1.5rem;
}

.permission-image {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0;
}

.permission-icon {
  width: 160px;
  height: auto;
}

.permission-text {
  max-width: fit-content;
}

.permission-content {
  padding-left: 0.5rem;
}

/* .permission-card .title {
  color: #222222;
  font-weight: 700;
  font-size: 2.5rem;
  line-height: 1.3;
  margin-bottom: 1.5rem;
  position: relative;
} */

/*  */

.permission-card .subtitle {
  color: #444444;
  font-weight: normal;
  font-size: 0.95rem;
  line-height: 1.4;
}

.permission-card .contact-text {
  color: #555555;
  font-size: 0.95rem;
}

.permission-card .button {
  min-width: 100px;
  font-weight: 500;
  border-radius: 4px;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

/* Add blur background styling */
.blur-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  opacity: 0.1;
  pointer-events: none;
}

/* Import external dashboard background styles */
@import "../../css/dashboard-bg.css";

.compliance-dashboard {
  position: relative;
}

/* Animation for card appearance */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
